<template>
    <div class="gallery">
        <div class="gallery-img" v-for="(item, idx) in images" :key="idx">
            <img :src="item.src" :alt="item.alt" />
        </div>
    </div>
</template>

<script>
export default {
    name : "Gallery",
    data() {
        return {
            images : [
                {
                    src : require('./../assets/image_gallery1.jpg'),
                    alt : "Image 1"
                },
                {
                    src : require('./../assets/image_gallery2.jpg'),
                    alt : "Image 2"
                },
                {
                    src : require('./../assets/image_gallery3.jpg'),
                    alt : "Image 3"
                },
                {
                    src : require('./../assets/image_gallery4.jpg'),
                    alt : "Image 4"
                },
                {
                    src : require('./../assets/image_gallery5.jpg'),
                    alt : "Image 5"
                },
            ]
        }
    },
}
</script>

<style lang="scss" scoped>
.gallery {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.gallery-img {
    margin:5px;
    width:calc(20% - 10px);
}

.gallery-img img {
    width:100%;
}

@media screen and (max-width:768px) {
    .gallery-img {
        margin:5px;
        width:calc(50% - 10px);
    }
}

</style>